import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import { Flex } from "theme-ui"

const SideNavBox = styled(Flex)`
    flex-direction: column;
    & ul {
        list-style-type: none;
        background: #fdfdfd;
        padding: 0;
        margin: 0;
        border-bottom: 0.5rem solid ${(props) => props.theme.colors.primary};
        text-align: left;
        & li {
            padding: 0.5rem 0 0.5rem 1rem;
            border-bottom: 1px solid ${(props) => props.theme.colors.primary};

            &:last-child {
                border-bottom: none;
            }
            &:hover {
                background: ${(props) => props.theme.colors.light_blue_1};
            }
            & a:hover {
                text-decoration: none;
            }
        }
    }
`
const Title = styled.div`
    text-align: center;
    margin-top: 0.5rem;
    background: ${(props) => props.theme.colors.primary};
    & p {
        color: ${(props) => props.theme.colors.background};
        font-weight: bold;
    }
`

const Index = ({ title, data, prefix, slug, children }) => {
    return (
        <SideNavBox>
            {children}
            <Title>
                <p>{title}</p>
            </Title>
            <ul className="content-paragraph">
                {data.map((page, index) => {
                    let arrSlug = page.node.slug.split("-")
                    if (arrSlug[0] === prefix) {
                        arrSlug.shift()
                    }
                    const urlSlug = arrSlug.join("-")
                    return (
                        <li key={index}>
                            <Link to={`/${slug}${urlSlug}`}>
                                {page.node.title}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </SideNavBox>
    )
}
export default Index
